import { useState } from 'react';

const EMPLEADOS_CONTRACTUALES = [
  'JuanG', 'LucaP', 'DanielaM', 'DiegoD', 'DiegoS',
  'OrelyC', 'StellaM', 'LucianaF', 'CandelaS', 'MagaliG',
  'PilarS', 'Augusto', 'PaulaC', 'MariaE', 'rosario',
];

export default function DashboardMonitoreo({ stros, estados, onSelectEmpleado, selectedEmpleado }) {

  const today = new Date();
  const todayStr = today.toISOString().split('T')[0];

  const in7Days = new Date(today);
  in7Days.setDate(in7Days.getDate() + 7);
  const in7DaysStr = in7Days.toISOString().split('T')[0];

  // Build per-employee stats
  const empleadoStats = EMPLEADOS_CONTRACTUALES.map(emp => {
    const empStros = stros.filter(s => s.empleadoAsignado === emp);
    const total = empStros.length;
    const vencidos = empStros.filter(s => s.fechaVencimiento && s.fechaVencimiento < todayStr).length;
    const vencenHoy = empStros.filter(s => s.fechaVencimiento === todayStr).length;
    const vencen7Dias = empStros.filter(s => {
      if (!s.fechaVencimiento) return false;
      return s.fechaVencimiento > todayStr && s.fechaVencimiento <= in7DaysStr;
    }).length;

    // Count estados
    const estadoCount = {};
    empStros.forEach(s => {
      if (s.estados && Array.isArray(s.estados)) {
        s.estados.forEach(estId => {
          estadoCount[estId] = (estadoCount[estId] || 0) + 1;
        });
      } else if (s.estadoNuevo) {
        estadoCount[s.estadoNuevo] = (estadoCount[s.estadoNuevo] || 0) + 1;
      }
    });

    return {
      nombre: emp,
      total,
      vencidos,
      vencenHoy,
      vencen7Dias,
      estadoCount,
      stros: empStros,
    };
  }).filter(e => e.total > 0) // Only show employees with cases
    .sort((a, b) => b.vencidos - a.vencidos || b.total - a.total);

  // Map estado IDs to names
  const estadoMap = {};
  if (estados && Array.isArray(estados)) {
    estados.forEach(e => {
      estadoMap[e.id] = e.nombre || e.estado || `Estado ${e.id}`;
    });
  }

  const handleSelectEmpleado = (emp) => {
    if (onSelectEmpleado) onSelectEmpleado(emp.nombre);
  };

  const selectedData = selectedEmpleado
    ? empleadoStats.find(e => e.nombre === selectedEmpleado)
    : null;

  // Get top estados for selected employee
  const selectedEstados = selectedData
    ? Object.entries(selectedData.estadoCount)
        .map(([id, count]) => ({
          id: Number(id),
          name: estadoMap[Number(id)] || `Estado ${id}`,
          count,
        }))
        .sort((a, b) => b.count - a.count)
        .slice(0, 6)
    : [];

  const maxEstadoCount = selectedEstados.length > 0
    ? Math.max(...selectedEstados.map(e => e.count))
    : 1;

  return (
    <div className='dashboard-card monitoreo-card'>
      <div className='dashboard-card-header'>
        <span className='dashboard-card-title'>
          <i className='bi bi-people-fill'></i>
          Monitoreo de Empleados — Contractuales
        </span>
        <span className='dashboard-card-badge'>
          {empleadoStats.length} empleados activos
        </span>
      </div>

      <div className='monitoreo-grid'>
        {/* Tabla de empleados */}
        <div className='monitoreo-table-wrapper'>
          <table className='monitoreo-table'>
            <thead>
              <tr>
                <th>Empleado</th>
                <th className='monitoreo-th-center'>Total</th>
                <th className='monitoreo-th-center'>Vencidos</th>
                <th className='monitoreo-th-center'>Hoy</th>
                <th className='monitoreo-th-center'>7 Días</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {empleadoStats.map(emp => (
                <tr
                  key={emp.nombre}
                  className={`monitoreo-row ${selectedEmpleado === emp.nombre ? 'monitoreo-row--selected' : ''}`}
                  onClick={() => handleSelectEmpleado(emp)}
                >
                  <td>
                    <div className='monitoreo-emp-cell'>
                      <div className='monitoreo-emp-avatar'>
                        {emp.nombre.substring(0, 2).toUpperCase()}
                      </div>
                      <span className='monitoreo-emp-name'>{emp.nombre}</span>
                    </div>
                  </td>
                  <td className='monitoreo-td-center'>
                    <span className='monitoreo-count'>{emp.total}</span>
                  </td>
                  <td className='monitoreo-td-center'>
                    <span className={`monitoreo-badge ${emp.vencidos > 0 ? 'monitoreo-badge--danger' : 'monitoreo-badge--ok'}`}>
                      {emp.vencidos}
                    </span>
                  </td>
                  <td className='monitoreo-td-center'>
                    <span className={`monitoreo-badge ${emp.vencenHoy > 0 ? 'monitoreo-badge--warning' : 'monitoreo-badge--ok'}`}>
                      {emp.vencenHoy}
                    </span>
                  </td>
                  <td className='monitoreo-td-center'>
                    <span className={`monitoreo-badge ${emp.vencen7Dias > 0 ? 'monitoreo-badge--info' : 'monitoreo-badge--ok'}`}>
                      {emp.vencen7Dias}
                    </span>
                  </td>
                  <td className='monitoreo-td-center'>
                    <i className={`bi ${selectedEmpleado === emp.nombre ? 'bi-chevron-up' : 'bi-chevron-down'}`}
                       style={{ fontSize: '12px', color: '#94a3b8' }}></i>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Detalle del empleado seleccionado */}
        {selectedData && (
          <div className='monitoreo-detail'>
            <div className='monitoreo-detail-header'>
              <div className='monitoreo-detail-avatar'>
                {selectedData.nombre.substring(0, 2).toUpperCase()}
              </div>
              <div>
                <div className='monitoreo-detail-name'>{selectedData.nombre}</div>
                <div className='monitoreo-detail-sub'>Detalle de siniestros asignados</div>
              </div>
            </div>

            {/* Mini KPIs */}
            <div className='monitoreo-mini-kpis'>
              <div className='monitoreo-mini-kpi'>
                <span className='monitoreo-mini-kpi-value'>{selectedData.total}</span>
                <span className='monitoreo-mini-kpi-label'>Total</span>
              </div>
              <div className='monitoreo-mini-kpi monitoreo-mini-kpi--danger'>
                <span className='monitoreo-mini-kpi-value'>{selectedData.vencidos}</span>
                <span className='monitoreo-mini-kpi-label'>Vencidos</span>
              </div>
              <div className='monitoreo-mini-kpi monitoreo-mini-kpi--warning'>
                <span className='monitoreo-mini-kpi-value'>{selectedData.vencenHoy}</span>
                <span className='monitoreo-mini-kpi-label'>Hoy</span>
              </div>
              <div className='monitoreo-mini-kpi monitoreo-mini-kpi--info'>
                <span className='monitoreo-mini-kpi-value'>{selectedData.vencen7Dias}</span>
                <span className='monitoreo-mini-kpi-label'>7 Días</span>
              </div>
            </div>

            {/* Estados breakdown */}
            {selectedEstados.length > 0 && (
              <div className='monitoreo-detail-section'>
                <div className='monitoreo-detail-section-title'>Distribución por Estado</div>
                <div className='monitoreo-detail-bars'>
                  {selectedEstados.map((est, idx) => (
                    <div className='monitoreo-bar-row' key={est.id}>
                      <span className='monitoreo-bar-label' title={est.name}>{est.name}</span>
                      <div className='monitoreo-bar-bg'>
                        <div
                          className={`monitoreo-bar-fill bar-color-${idx % 10}`}
                          style={{ width: `${(est.count / maxEstadoCount) * 100}%` }}
                        />
                      </div>
                      <span className='monitoreo-bar-count'>{est.count}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Recent vencimientos */}
            <div className='monitoreo-detail-section'>
              <div className='monitoreo-detail-section-title'>Próximos Vencimientos</div>
              <div className='monitoreo-venc-list'>
                {selectedData.stros
                  .filter(s => s.fechaVencimiento)
                  .sort((a, b) => (a.fechaVencimiento || '').localeCompare(b.fechaVencimiento || ''))
                  .slice(0, 8)
                  .map((s, idx) => {
                    let urgClass = 'proximo';
                    if (s.fechaVencimiento < todayStr) urgClass = 'vencido';
                    else if (s.fechaVencimiento === todayStr) urgClass = 'hoy';

                    return (
                      <div className='monitoreo-venc-item' key={s.id || idx}>
                        <div className={`monitoreo-venc-dot monitoreo-venc-dot--${urgClass}`}></div>
                        <div className='monitoreo-venc-info'>
                          <span className='monitoreo-venc-nro'>
                            Stro #{s.nroStro?.toString().slice(3) || s.nroStro}
                          </span>
                          <span className='monitoreo-venc-fecha'>
                            {s.fechaVencimiento?.split('-').reverse().join('/')}
                          </span>
                        </div>
                        <span className='monitoreo-venc-dom'>{s.dom || '—'}</span>
                      </div>
                    );
                  })}
                {selectedData.stros.filter(s => s.fechaVencimiento).length === 0 && (
                  <div style={{ fontSize: '12px', color: '#94a3b8', padding: '12px', textAlign: 'center' }}>
                    Sin vencimientos registrados
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
